"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MicOffFillYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_MicOffFillYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 10,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.838 11.869.709-.709A3.999 3.999 0 0 0 12 8c0-.28.22-.5.5-.5s.5.22.5.5c0 .03 0 .07-.01.1-.04 2.54-1.99 4.62-4.49 4.87V15h2c.28 0 .5.22.5.5s-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2v-2.03a4.985 4.985 0 0 1-2.662-1.101Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26 10.447 11 5.707V8c0 1.66-1.34 3-3 3a2.99 2.99 0 0 1-1.74-.553ZM8 0a2.996 2.996 0 0 1 2.998 2.88L5.1 8.778A3.016 3.016 0 0 1 5 8V3c0-1.66 1.34-3 3-3ZM4.316 9.562A3.99 3.99 0 0 1 4 8c0-.28-.22-.5-.5-.5a.495.495 0 0 0-.49.6c.013.796.213 1.547.558 2.21l.748-.748Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MicOffFillYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131619",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_MicOffFillYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.146a.5.5 0 0 1 0 .708l-15 15a.5.5 0 0 1-.708-.708l15-15a.5.5 0 0 1 .708 0Z",
    fill: "#ED4D6A"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MicOffFillYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F21F31",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = MicOffFillYes;
exports["default"] = _default;